module.exports = __webpack_public_path__ + "static/img/phone.85be6958.svg";